import type { ReactNode } from 'react';
import { useTheme } from '../../app/theme';
import styles from './AuthLayout.module.css';

export interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}

/**
 * Auth-page brand row — full Toado logo. We swap variants by theme so
 * the wordmark always has enough contrast: the "white" asset is meant
 * for dark surfaces, the regular asset for light. URLs need their
 * literal spaces encoded.
 */
export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  const { theme } = useTheme();
  const logoSrc = theme === 'dark' ? '/toado%20logo%20white.svg' : '/toado%20logo.svg';
  return (
    <div className={styles.shell}>
      <div className={styles.card}>
        <div className={styles.brand}>
          <img
            src={logoSrc}
            alt="Toado"
            className={styles.brandLogo}
          />
        </div>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.sub}>{subtitle}</p>}
        <div className={styles.body}>{children}</div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>
  );
}
